import { FEATURE_FLAGS } from '@/constants/featureFlags';

/**
 * Join peek (Track 6, experiment 2): on allowlisted programs a signed-out visitor may
 * dismiss the join box and look at the guide before giving an email. Same allowlist
 * grammar as the auto-save soak: '*' or comma-separated Program ids.
 */
export function isJoinPeekProgram(
  programId: string | null | undefined,
  raw: string | undefined | null = FEATURE_FLAGS.JOIN_PEEK_PROGRAMS
): boolean {
  if (!programId || !raw) return false;
  const list = String(raw)
    .split(',')
    .map(s => s.trim())
    .filter(Boolean);
  if (!list.length) return false;
  return list.includes('*') || list.includes(String(programId));
}
